import FilterAltOutlined from '@mui/icons-material/FilterAltOutlined';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

interface ScopeLabelProps {
  title: string;
}

export function ScopeLabel({ title }: ScopeLabelProps): ReactNode {
  return (
    <Box
      title={title}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        fontSize: 11,
        fontWeight: 700,
        textTransform: 'uppercase',
        color: 'text.disabled',
        pr: 1,
      }}
    >
      <FilterAltOutlined sx={{ fontSize: 13, color: 'text.secondary' }} />
      Scope
    </Box>
  );
}
